
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import EventsSection from './components/EventsSection';
import SermonsSection from './components/SermonsSection';
import BlogSection from './components/BlogSection';
import ContactSection from './components/ContactSection';
import DonateSection from './components/DonateSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-neutral-50" style={{ scrollBehavior: 'smooth' }}>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <EventsSection />
        <SermonsSection />
        <BlogSection />
        <ContactSection />
        <DonateSection />
      </main>
      <Footer />
    </div>
  );
}
